module.exports = __webpack_public_path__ + "static/media/manu.d58210e1.webp";